import axios from 'axios'
import Error_500 from '../components/error/error-500'
import { API_LNK, AUTH, KEY_LNK } from '../Constants'

const postLnk = async (path, data = {}) => {
  return await axios({
    method: 'POST',
    url: `${API_LNK}${path}`,
    headers: {
      'x-api-key': KEY_LNK,
      authorization: AUTH
    },
    data
  })
    .then((response) => {
      if (!response) return
      return response.data
    })
    .catch((error) => {
      Error_500(error)
    })
}
const getLnk = async (path, params = {}) => {
  return await axios({
    method: 'GET',
    url: `${API_LNK}${path}`,
    headers: {
      'x-api-key': KEY_LNK,
      authorization: AUTH
    },
    params
  })
    .then((response) => {
      if (!response) return
      return response.data
    })
    .catch((error) => {
      Error_500(error)
    })
}

export const getShortUrlsLinkAPI = async (data) => {
  return await getLnk('short-urls', data)
}

export const createShortUrlsLinkAPI = async (data) => {
  return await postLnk('short-urls', data)
}
